import { AgyCLIOAuthPlugin, GoogleOAuthPlugin } from "./src/plugin";

export { AgyCLIOAuthPlugin, GoogleOAuthPlugin };

export default {
  id: "@anthonyhaussman/opencode-agy-auth",
  server: AgyCLIOAuthPlugin,
};
